module.exports = __webpack_public_path__ + "img/chara_4.ccc820a4.png";